import { render, staticRenderFns } from "./CategoriesSelect.vue?vue&type=template&id=fbdc5fa6&scoped=true"
import script from "./CategoriesSelect.vue?vue&type=script&lang=ts"
export * from "./CategoriesSelect.vue?vue&type=script&lang=ts"
import style0 from "./CategoriesSelect.vue?vue&type=style&index=0&id=fbdc5fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdc5fa6",
  null
  
)

export default component.exports